import { useLayoutEffect } from 'react';

// Hack to remove focus trap from Drawer https://github.com/emilkowalski/vaul/issues/497

export const useFocusTrapReset = () => {
  useLayoutEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    function handleFocus(e: FocusEvent) {
      e.stopImmediatePropagation();
    }
    document.addEventListener('focusin', handleFocus, { signal });
    document.addEventListener('focusout', handleFocus, { signal });
    return () => {
      controller.abort();
    };
  }, []);
};
